import { render } from "./VideoPopup.vue?vue&type=template&id=6d2d9b1c&scoped=true"
import script from "./VideoPopup.vue?vue&type=script&lang=js"
export * from "./VideoPopup.vue?vue&type=script&lang=js"

import "./VideoPopup.vue?vue&type=style&index=0&id=6d2d9b1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2d9b1c"]])

export default __exports__